<template>
  <div class="header">
    <img src="../assets/imgs/join_header.png" alt="" />
  </div>
  <div class="jobs">
    <div class="job">
      <div class="title">
        {{ job.name }}
      </div>
      <div class="sub_title">{{ job.education }} | {{ job.work_year }}</div>
      <div class="sm_title">岗位描述</div>
      <div class="descript">
        <div v-for="(p, ind) of job.description" :key="ind">
          {{ ind+1 }}：{{ p }}
        </div>
      </div>
      <div class="sm_title">任职要求</div>
      <div class="need">
        <div v-for="(p, ind) of job.requirement" :key="ind">
          {{ ind+1 }}：{{ p }}
        </div>
      </div>
      <div class="connect">简历请投邮箱：hr@smart-path.net</div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref } from "@vue/reactivity";
export default {
  components: {},
  setup() {
    const job = ref<any>(JSON.parse(localStorage.jobDetail));
    return {
      job,
    };
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 1200px;
  margin: 0 auto;
  font-size: 0px;
  img {
    width: 1920px;
    margin-left: -360px;
  }
}
.jobs {
  background: #fff;
  padding-bottom: 52px;
  .job {
    width: 800px;
    margin: 0 auto;
    padding-top: 74px;
    .title {
      font-size: 30px;
      color: #2c2d3f;
      font-weight: bold;
    }
    .sub_title {
      font-size: 16px;
      color: #596675;
      margin-top: 12px;
    }
    .sm_title {
      font-size: 20px;
      color: #2c2d3f;
      font-weight: bold;
      margin-top: 50px;
      margin-bottom: 20px;
    }
    .descript,
    .need {
      white-space: pre-line;
      line-height: 32px;
      color: #596675;
      font-size: 16px;
    }
    .connect {
      color: #596675;
      font-size: 20px;
      text-align: center;
      margin-top: 44px;
    }
  }
}
</style>